class ProductVariantController {
  constructor(productContainer) {
    this.container = productContainer;
    this.form = this.container.querySelector('form');
    this.submitButton = this.form?.querySelector('button[type="submit"]');
    this.submitButtonText = this.submitButton?.querySelector('span');
    this.defaultButtonText = this.submitButtonText?.textContent;
    this.imageElement = this.container.querySelector('image-element img');
    this.priceElement = this.container.querySelector('.grid-product__price');
    this.salePriceElement = this.container?.querySelector('option[data-variant-compare-at-price]');
    this.variantInput = this.form?.querySelector('input[name="id"]');
    this.variantSelect = this.form?.querySelector('select[product-variant-option]');
    this.productLink = this.container.querySelector('.grid-product__link');
    this.variantUrl = this.productLink?.getAttribute('href');

    if (this.variantSelect) {
      this.handleVariantChange(this.variantSelect);
      this.variantSelect.addEventListener('change', () => {
        this.handleVariantChange(this.variantSelect);
      });
    }
    this.initializeFormSubmission();
  }

  updateImage(newSrc) {
    if (this.imageElement && newSrc) {
      this.imageElement.src = newSrc;
      this.imageElement.srcset = newSrc;
    }
  }

  updatePrice(price) {
    if (this.priceElement && price) {
      this.priceElement.textContent = price;
    }
  }


  updateSalePrice(regularPrice, salePrice) {
    if(regularPrice && salePrice){
    this.priceElement.innerHTML = `
      <span class="visually-hidden">${theme.strings.regularPrice}</span>
      <span class="grid-product__price--original">
        ${regularPrice}</span>
      <span class="visually-hidden">${theme.strings.salePrice}</span>
      ${salePrice}`
    }
  }

  updateVariantId(variantId) {
    if (this.variantInput && variantId) {
      this.variantInput.value = variantId;
    }
  }

  updateVariantUrl(variantId) {
    if (this.variantUrl && variantId) {
      const baseUrl = this.productLink.getAttribute('href').split('?')[0];
      const newUrl = `${baseUrl}?variant=${variantId}`;
      this.productLink.setAttribute('href', newUrl);
    }
  }

  handleVariantChange(select) {
    const selectedOption = select.options[select.selectedIndex];
    const compareAtPrice = selectedOption?.dataset?.variantCompareAtPrice || null;
    const productPrice = selectedOption?.dataset?.variantPrice || null;

    if (!selectedOption) return;

    this.updateImage(selectedOption.dataset.image);
    this.updateVariantId(selectedOption.value);
    this.updateVariantUrl(selectedOption.value);

    if (!productPrice) return; 

    if (compareAtPrice) {
        this.updateSalePrice(compareAtPrice, productPrice);
    } else {
        this.updatePrice(productPrice);
    }
  }

  initializeFormSubmission() {
    this.form?.addEventListener('submit', this.handleSubmit.bind(this));
  }

  async handleSubmit(e) {
    e.preventDefault();
    const formData = new FormData(this.form);
    this.setLoading(true);

    try {
      const response = await fetch("/cart/add.js", {
        method: 'POST',
        body: formData
      });

      if (!response.ok) throw new Error('Add to cart failed!');
      
      if ( typeof theme !== 'undefined' && theme.settings && theme.settings.cartType === "modal" ) {
        const product = await response.json();
        
        // Dispatch the event that triggers the modal
        document.dispatchEvent(new CustomEvent('product:addedToCartModal', {
          detail: { product: product }
        }));
      }

    } catch(error) {
      console.error('Error adding to cart:', error);
    } finally {
      this.setLoading(false);
    }

    ['cart:build', 'cart:open'].forEach(event => {
      document.dispatchEvent(new Event(event));
    });
  }

  setLoading(isLoading) {
    if(isLoading) {
      this.submitButton.disabled = true;
      this.submitButtonText.textContent = "Adding...";
    } else {
      this.submitButton.disabled = false;
      this.submitButtonText.textContent = this.defaultButtonText;
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  initializeProductGrid();

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.addedNodes.length) {
        const hasProductItems = Array.from(mutation.addedNodes).some(node => {
          if (node.nodeType !== Node.ELEMENT_NODE) return false;

          if (node.classList && node.classList.contains('grid-product__content')) {
            return true;
          }

          return node.querySelector && node.querySelector('.grid-product__content') !== null;
        });

        if (hasProductItems) {
          initializeProductGrid();
        }
      }
    }
  });

  // Start observing the product grid container
  const productGridContainer = document.querySelector('.collection-grid');

  if (productGridContainer) {
    observer.observe(productGridContainer, { childList: true, subtree: true });
  } else {
    // Fallback to a more generic container or the body if the specific container isn't found
    const fallbackContainer = document.querySelector('.main-content') || document.body;
    observer.observe(fallbackContainer, { childList: true, subtree: true });
  }
});

// Fallback initialization
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeProductGrid);
} else {
  // DOM already loaded
  initializeProductGrid();
}

// Also try with a small delay for dynamic content
setTimeout(initializeProductGrid, 100);

function initializeProductGrid() {
  const productGrid = document.querySelector('.products-grid');
  if (!productGrid) return;

  document.querySelectorAll('.grid-product__content').forEach(container => {
    if (!container.hasAttribute('data-initialized')) {
      new ProductVariantController(container);
      container.setAttribute('data-initialized', 'true');
    }
  });

  document.querySelectorAll('.color-swatch:not([data-initialized])').forEach(swatch => {

    // Skip if this swatch is inside product-single__meta
    if (swatch.closest('.product-single__meta')) {
      return; // Skip this iteration in main PDP swatches.
    }
    
    const productSplitGalleryFloatingProductCard = document.querySelector('.split-gallery-floating-product-card');
    if(!productSplitGalleryFloatingProductCard) {
      swatch.addEventListener('click', function(event) {
        event.preventDefault();
        
        // Get the color name from data-color attribute
        const colorName = this.getAttribute('data-color');
        const colorWrapper = this.closest('.grid-product__content')?.querySelector('.grid-product__colors-wrapper');
        
        // Remove any existing color displays
        const existingDisplay = colorWrapper?.querySelector('.color-swatch-display');
        if (existingDisplay) {
          existingDisplay.remove();
        }
        
        // Create and show color display if color name exists
        if (colorName && colorWrapper) {
          const colorDisplay = document.createElement('div');
          colorDisplay.className = 'color-swatch-display';
          colorDisplay.textContent = colorName;
          
          // Append inside the wrapper
          colorWrapper.appendChild(colorDisplay);
        }
        
        const variantId = this.getAttribute('data-variant-id');
        const productSelect = this.closest('.grid-product__content')?.querySelector('.product-form__select');
        const matchingOption = Array.from(productSelect?.options).find(
          option => option.value === variantId
        );
        if(matchingOption) {
          productSelect.value = variantId;

          const changeEvent = new Event('change', { bubbles: true});
          productSelect.dispatchEvent(changeEvent);
        }
      });
      swatch.setAttribute('data-initialized', 'true');
    }
  });

  // document.querySelectorAll(".grid-product__colors-wrapper").forEach(colorWrapper => {
  //   const dropDownForm = colorWrapper.parentElement.querySelector("form");
  //   if (dropDownForm) {
  //     dropDownForm.querySelectorAll(".product-form__label, .product-form__select").forEach(element => {
  //       element.classList.add("hide");
  //     });
  //   }
  // });

  productGridItemHeight();
}

window.addEventListener('resize', productGridItemHeight);

function productGridItemHeight() {
  const metaElements = document.querySelectorAll('.grid-product__meta');

  if( metaElements.length === 0) return;

  metaElements.forEach(element => {
    element.style.height = 'auto';
  });

  let maxHeight = 0;
  metaElements.forEach(element => {
    const height = element.offsetHeight;
    if (height > maxHeight) {
      maxHeight = height
    }
  });

  metaElements.forEach(element => {
    element.style.height = `${maxHeight}px`;
  });

  // document.querySelectorAll('.grid-product__content').forEach(element => {
  //   element.style.minHeight = '';
  // });

  // document.querySelectorAll('.grid-product__content form').forEach(form => {
  //   form.removeAttribute('style');
  // });

  // const elements = document.querySelectorAll('.grid-product__content');
  // let maxHeight = 0;

  // elements.forEach(element => {
  //   const elementHeight = element.offsetHeight;
  //   maxHeight = Math.max(maxHeight, elementHeight);
  // });

  // document.querySelectorAll('.grid-product__content').forEach(element => {
  //   element.style.minHeight = `${maxHeight}px`;
  // });
}